import { difference, isEqual, omit } from "lodash";
import { v4 as uuid } from "uuid";

export const getCreditListId = (creditMonth) =>
  `${creditMonth.year}_${creditMonth.month}`;

export const createCreditList = (creditMonthList) => {
  return creditMonthList.map((creditMonth) => ({
    creditMonth,
    id: getCreditListId(creditMonth),
    credits: [],
  }));
};

export const combineCreditList = (creditList, credits, creditListItemId) => {
  return creditList.map((creditItem) => {
    if (creditItem.id !== creditListItemId) {
      return creditItem;
    }

    return {
      ...creditItem,
      credits,
    };
  });
};

export const prepareCredits = (credits) => {
  return credits.map((credit) => ({ ...credit, uuid: uuid() }));
};

export const isCreditSelected = (selectedCredits, creditId) => {
  return selectedCredits.includes(creditId);
};

export const isCreditMonthSelected = (selectedCreditIds, monthCreditIds) => {
  return (
    monthCreditIds.length &&
    difference(monthCreditIds, selectedCreditIds).length === 0
  );
};

export const isAllMonthDataLoaded = (creditList) => {
  return creditList.every((item) => item.credits.length);
};

export const isAllCreditsSelected = (selectedCreditIds, creditList) => {
  if (!isAllMonthDataLoaded(creditList)) {
    return false;
  }

  const allCreditList = creditList
    .reduce((acc, item) => [...acc, ...item.credits], [])
    .map((item) => item.uuid);

  return difference(allCreditList, selectedCreditIds).length === 0;
};

export const getClaimedContentIds = (claimedUnits) =>
  claimedUnits.reduce((result, unit) => {
    if (!unit.checked) {
      result.push(unit.availableCreditId);
    }
    return result;
  }, []);

export const handleClaimedContent = (claimedUnits, value) =>
  claimedUnits.map((unit) => {
    if (String(unit.availableCreditId) === value) {
      unit.checked = !unit.checked;
    }
    return unit;
  });

export const isSavedCredit = (credit) => {
  return credit?.id !== undefined;
};

export const mergeCredits = (creditList, creditsToMerge) => {
  return creditList.map((creditListItem) => ({
    ...creditListItem,
    credits: creditListItem.credits.map((credit) => {
      const creditToMerge = creditsToMerge.find((el) =>
        isEqual(omit(credit, ["uuid"]), omit(el, ["id"]))
      );

      return creditToMerge ? { ...credit, ...creditToMerge } : credit;
    }),
  }));
};

export const isNotSelectedUnits = (claimedUnits, preparedUnits) =>
  claimedUnits.every((item) => !item.checked) &&
  preparedUnits.length === claimedUnits.length;
